import type { Dataset } from '@life/data';
import { createGame, type Game } from './game';
import { load, type LoadResult } from './storage';

export type LoadError = Exclude<Extract<LoadResult, { ok: false }>['reason'], 'empty'>;

export interface Boot {
  game: Game;
  /** Почему сохранение не прочитано: мусор или чужая версия; null — прочитано или его не было. */
  loadError: LoadError | null;
}

/** Фиксированный seed жизни из строки запроса (`?seed=…`) — для E2E и воспроизведения; пустой — нет. */
export function seedFromSearch(search: string): string | undefined {
  const seed = new URLSearchParams(search).get('seed');
  return seed ? seed : undefined;
}

/**
 * Старт клиента: читает сохранение и поднимает стор. Мусор или чужая
 * версия не роняют приложение — стор пустой, а стартовый экран показывает
 * сообщение (Review Focus 1). `storage` не передан — localStorage браузера.
 * `search` — строка запроса страницы: `?seed=` задаёт seed новых жизней
 * (E2E, план 2b Task 11); без неё seed случайный.
 */
export function boot(ds: Dataset, storage?: Storage | null, search = ''): Boot {
  const loaded = storage === undefined ? load(undefined, ds) : load(storage, ds);
  const seed = seedFromSearch(search);
  const game = createGame(ds, loaded.ok ? loaded.save : null, storage, seed === undefined ? {} : { seed });
  const loadError = loaded.ok || loaded.reason === 'empty' ? null : loaded.reason;
  return { game, loadError };
}
